import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MEModal from '../../../components/MEModal.js'
import { hideDeleteCourseModal, deleteCourse } from '../actions'

const RemoveCourseModal = props => {
  let courseMap = props.connectedCourses.reduce((map, course) => {
    map[course.id] = { ...course }
    return map
  }, {})

  let text = props.courseDeleteId ? (
    <div>
      Are you sure you want to remove:{' '}
      <b>{courseMap[props.courseDeleteId].coursenum}</b> from this organization?
    </div>
  ) : null

  let deleteWrapper = () => {
    let courseData = courseMap[props.courseDeleteId]
    props.hideDeleteCourseModal()
    props.deleteCourse(courseData)
  }

  let deleteAction = props.courseDeleteId ? deleteWrapper : null
  return (
    <div>
      <MEModal
        show={props.show}
        close={props.close}
        title="Remove Course from Organization?"
      >
        {text}
        <div className="mt-4">
          <button onClick={deleteAction} className="btn btn-danger mr-2">
            Delete
          </button>
          <button
            onClick={props.hideDeleteCourseModal}
            className="btn btn-myed btn-default btn-default-myed"
          >
            Cancel
          </button>
        </div>
      </MEModal>
    </div>
  )
}

RemoveCourseModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  connectedCourses: PropTypes.array,
  courseDeleteId: PropTypes.string,
  hideDeleteCourseModal: PropTypes.func,
  deleteCourse: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    connectedCourses: state.connectedCourses,
    courseDeleteId: state.courseDeleteId,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    hideDeleteCourseModal: () => {
      dispatch(hideDeleteCourseModal())
    },
    deleteCourse: courseData => {
      dispatch(deleteCourse(courseData))
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(RemoveCourseModal)
